module.exports = __webpack_public_path__ + "static/media/eppan.31848e70.jpg";